module.exports = __webpack_public_path__ + "static/0chain-privacy-8a7df3e5f9b381646c76477d9b63fefe.png";